import { getFullScreenSize } from '@/utils/layout';
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import './index.scss';
import VapView from '@/components/vap-view';
import { useEffect, useRef, useState, createElement } from '@max/max';
import { Animated } from '@max/mbc-animated';
import AnimatedView from '@max/mbc-animate-view';
import { BID_MAP, INVITE_REWARD_VAP } from '@/const';
import { MTNewDigitalDisplayStyle } from '@/utils/common';
const isWeb = true;
const isMRN = false;
import ModalBottomBtn from '../modal-bottom-button';
import Sensor from '@max/mbc-sensor';
import { isTitansAppOrWebview } from '@nibfe/mkt-env-api';
const isUseAnimated = false;
export default function InvitePopup(props) {
    const { fullScreenHeight, fullScreenWidth } = getFullScreenSize();
    const opacity = useRef(new Animated.Value(0));
    const timerRef = useRef(null);
    const [timeoutNum, setTimeoutNum] = useState(props.autoJumpBrowsePageDuration || 0);
    const timeoutRef = useRef(null);
    const rewardTranslateY = useRef(new Animated.Value(25));
    const rewardOpacity = useRef(new Animated.Value(0));
    const rewardVapOpacity = useRef(new Animated.Value(1));
    function onGotoBrowsePage() {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.TASK_BROWSE_MC, {
            type: 'invitePopup'
        });
        props.inviteBrowse();
    }
    // 进入页面3s后，如果没有点击跳转，则自动跳转
    useEffect(() => {
        if (props.invitePopupVisible && typeof props.autoJumpBrowsePageDuration === 'number' && props.autoJumpBrowsePageDuration > 0) {
            timerRef.current = setTimeout(() => {
                onGotoBrowsePage();
            }, props.autoJumpBrowsePageDuration);
            timeoutRef.current = setInterval(() => {
                setTimeoutNum(t => {
                    if (t <= 0) {
                        clearInterval(timeoutRef.current);
                        return 0;
                    }
                    return t - 1000;
                });
            }, 1000);
        }
        return () => clearTimeout(timerRef.current);
    }, [props.invitePopupVisible]);
    const showCardAnimation = () => {
        Animated.parallel([Animated.timing(rewardTranslateY.current, {
                toValue: 0,
                duration: 100,
                useNativeDriver: true,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0)
            }), Animated.timing(rewardOpacity.current, {
                toValue: 1,
                duration: 100,
                useNativeDriver: true,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0)
            })]).start();
    };
    if (!props.invitePopupVisible) {
        return null;
    }
    const renderCardContent = () => {
        return <>
        <AnimatedView viewId="invite-popup-reward-amount-vap" style={{
            opacity: rewardVapOpacity.current
        }}>
          <VapView {...INVITE_REWARD_VAP} widthHeightRatio={360 / 190} height={isTitansAppOrWebview() ? '190rpx' : '60rpx'} width={isTitansAppOrWebview() ? '240rpx' : '120rpx'} widthInRpx={240} style={{
            top: isTitansAppOrWebview() ? '70rpx' : '150rpx',
            left: isTitansAppOrWebview() ? '160rpx' : '220rpx',
            position: 'absolute'
        }} keepLastFrame loop={false} playPointActions={[{
                microseconds: 500,
                action: () => {
                    Animated.timing(rewardVapOpacity.current, {
                        toValue: 0,
                        duration: 100,
                        useNativeDriver: true,
                        easing: Animated.Easing.out(Animated.Easing.cubic)
                    }).start();
                }
            }, {
                microseconds: 500,
                action: () => {
                    showCardAnimation();
                }
            }]}/>
        </AnimatedView>

        <View className="invite-popup-card" style={{
            // paddingTop: props.inTeam ? '420rpx' : '360rpx',
            paddingTop: '109rpx'
        }}>
          <View style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: isMRN ? 'flex-start' : 'baseline',
            position: 'relative',
            justifyContent: 'center',
            marginLeft: '-90rpx'
        }}>
            <View className="invite-popup-call-icon-container" style={{
            marginTop: isMRN ? '75rpx' : '0rpx'
        }}>
              <LImage source={{
            uri: 'https://p0.meituan.net/ingee/0e5afcae95732fdb08dce3fc867e0892739.png'
        }} style={{
            width: '20rpx',
            height: '22rpx',
            marginRight: '6.5rpx'
        }} className="invite-popup-call-icon"/>
              <Text className="invite-popup-call-label">{props.callValueDesc || 'Call值'}</Text>
            </View>
            <AnimatedView viewId="invite-popup-reward-amount" style={{
            transform: [{
                    translateY: rewardTranslateY.current
                }],
            opacity: rewardOpacity.current
        }}>
              
              <Text className="invite-popup-reward-amount" style={MTNewDigitalDisplayStyle}>
                {props.inviteTeamValue || 100}
              </Text>
            </AnimatedView>
          </View>

          
          <Text className="invite-popup-description" style={{
            marginTop: isWeb ? '0rpx' : '-20rpx'
        }}>
            {props.gotInvitePoints && props.rewardAmount > 0 ? props.rewardDesc : props.noRewardDesc}
          </Text>
          {!props.inTeam ? <>
              <View style={{
            marginTop: '81rpx'
        }}>
                <ModalBottomBtn buttonText={`${timeoutNum > 0 ? `${timeoutNum / 1000}s后` : '点击浏览'}${props.callValueDesc || 'Call值'}翻倍`} onPress={() => {
            onGotoBrowsePage();
        }}/>
                <LImage source={{
            uri: 'https://p0.meituan.net/ingee/af1d9184acb9a0ad75666d431e68cc543164.png'
        }} style={{
            width: '120rpx',
            height: '36rpx',
            position: 'absolute',
            right: '0rpx',
            top: '-18rpx'
        }}/>
              </View>
              <LImage onPress={props.onClickJoinTeam} source={{
            uri: 'https://p0.meituan.net/ingee/f11d84aa9f6d947701014d364bcb0a705065.png'
        }} style={{
            width: '503rpx',
            height: '90rpx',
            position: 'relative',
            overflow: 'visible',
            marginTop: '24rpx'
        }}>
                
                
              </LImage>

              
            </> : <>
              <View style={{
            marginTop: '81rpx'
        }}>
                <ModalBottomBtn buttonText={`${timeoutNum > 0 ? `${timeoutNum / 1000}s后` : '点击浏览'}${props.callValueDesc || 'Call值'}翻倍`} onPress={() => {
            onGotoBrowsePage();
        }}/>
                <LImage source={{
            uri: 'https://p0.meituan.net/ingee/af1d9184acb9a0ad75666d431e68cc543164.png'
        }} style={{
            width: '120rpx',
            height: '36rpx',
            position: 'absolute',
            right: '0rpx',
            top: '-18rpx'
        }}/>
              </View>
              <LImage onPress={props.onClickInviteCall} source={{
            uri: 'https://p0.meituan.net/ingee/cee7506b9aed99dbef62d4c130e0ac745071.png'
        }} style={{
            width: '503rpx',
            height: '90rpx',
            position: 'relative',
            overflow: 'visible',
            marginTop: '24rpx'
        }}></LImage>
              
            </>}
        </View>
      </>;
    };
    return <TopView>
      <ModalBaseContainer visible={props.invitePopupVisible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    }}>
        
        


        <View style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '333rpx'
    }}>
          <LImage className='invite-popup-head-image' source={{
        uri: 'https://p0.meituan.net/ingee/5244916939ebae772bbf0e14835f4c7a35424.png'
    }} style={{
        width: "400rpx",
        height: "130rpx",
        marginBottom: "33rpx"
    }}></LImage>
          <LImage className='invite-popup-card-bg-image' source={{
        uri: "https://p0.meituan.net/ingee/36755412bd3f5da581c69d92e2acaad49921.png"
    }} style={{
        width: "566rpx",
        height: "619rpx"
    }}>
            {renderCardContent()}
          </LImage>
          
          <LImage onPress={props.closeInviteCallPopup} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx'
    }} className="invite-popup-close-btn"/>
        </View>
        <Sensor onAppear={() => {
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.INVITE_POPUP_MV, {
            type: 'invitePopup'
        });
    }}></Sensor>
      </ModalBaseContainer>
    </TopView>;
}
